import { render, staticRenderFns } from "./UsageHistoryComponent.vue?vue&type=template&id=e0bf4514&scoped=true"
import script from "./UsageHistoryComponent.vue?vue&type=script&lang=js"
export * from "./UsageHistoryComponent.vue?vue&type=script&lang=js"
import "./UsageHistoryComponent.vue?vue&type=style&index=0&id=e0bf4514&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0bf4514",
  null
  
)

export default component.exports